<template>
  <div>
    <a-form layout="horizontal" :form="form" @submit="handleSubmit">
      <a-form-item label="原密码" :label-col=" { span: 4 }" :wrapper-col=" { span: 14 }">
        <a-col :span="8">
          <a-input
            v-model="mdl.oldPassword"
            type="password"
            placeholder
            v-decorator="[
                    'mdl.ldPassword',
                    {
                      rules: [{ required: true, message: '请输入原密码!' }],
                    }]"
          />
        </a-col>
      </a-form-item>
      <a-form-item
        label="新密码"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-col :span="8">
          <a-input
            v-model="mdl.password"
            type="password"
            placeholder
            v-decorator="[
                    'mdl.password',
                    {
                      rules: [{ required: true, message: '请输入密码!' }],
                    }]"
          />
        </a-col>
      </a-form-item>

      <a-form-item
        label="确认新密码"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-col :span="8">
          <a-input
            v-model="mdl.confirmPassword"
            type="password"
            placeholder
            v-decorator="[
                    'mdl.confirmPassword',
                    {
                      rules: [{ required: true, message: '请输入确认密码!' }],
                    }]"
          />
        </a-col>
      </a-form-item>
      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <a-button type="primary" html-type="submit">确认提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { userModifyPassword } from '@/api/sys'
export default {
  data() {
    return {
      formLayout: 'horizontal',
      mdl: {},
      form: this.$form.createForm(this)
    }
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this
      return {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 }
      }
    },
    buttonItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            wrapperCol: { span: 14, offset: 4 }
          }
        : {}
    }
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault()
      const _this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          if (_this.mdl.password !== _this.mdl.confirmPassword) {
            _this.$message.warning('两次输入密码不一致', 3)
            return
          }
          userModifyPassword(Object.assign({}, _this.mdl))
            .then(res => {})
            .catch(() => {})
            .finally(() => {
              // _this.confirmLoading = false
            })
        }
      })
    }

    //   handleFormLayoutChange  (e) {
    //     this.formLayout = e.target.value;
    //   },
  }
}
</script>

<style scoped>
.components-input-demo-size .ant-input {
  width: 200px;
  margin: 0 8px 8px 0;
}
</style>